import type { ReactElement, SVGProps } from 'react'
import { Icon } from './Icon'

export function GoCd(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <Icon viewBox="0 0 138 138" {...props}>
      <g data-name="Layer 2">
        <path
          d="M103.75 76.11l-51.22 34.13a8.45 8.45 0 01-4.73 1.44 8.33 8.33 0 01-4-1 8.51 8.51 0 01-4.51-7.52V69a8.52 8.52 0 1117 0v18.19L83.59 69 43 42a8.54 8.54 0 119.5-14.27l51.25 34.16a8.58 8.58 0 010 14.22M69 0a69 69 0 1069 69A69.07 69.07 0 0069 0"
          data-name="Layer 1"
        />
      </g>
    </Icon>
  )
}
